import { app } from '@/main';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';

export const getBillingIsPending = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;
  const subscription = app.$store.getters['business/getBillingSubscription'];

  if (!business || !subscription) return false;

  return (
    business.subscriptionStatus === EBillingStatusTypes.PENDING &&
    !subscription.status
  );
};

export const getBillingOnboardingCallPending = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;
  const subscription = app.$store.getters['business/getBillingSubscription'];

  if (!business || !subscription) return false;

  return (
    business.subscriptionStatus === EBillingStatusTypes.PENDING &&
    subscription.status === EBillingStatusTypes.PENDING
  );
};
